const InputVariant = {
  FullWidth: 'fullWidth',
  LoginRegister: 'loginRegister',
  Default: '_default',
};

export default InputVariant;
